module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/node-libs-browser/node_modules/util/support/isBufferBrowser.js
// module id = 698
// module chunks = 8 88